import styled from 'styled-components';

export const FormIconWrapper = styled.span`
    display: inline-flex;
    gap: var(--space-xsm);
    align-items: center;
`;
